import Api from '@/api'

export default {
    state: {
        msg: '',
        info: {},
        userList: [],
        userAllList: [],
        totleNum: 0,
        userCount: 0,
        userTotalPage: 0,
        userPageNo: 1,
        blocks: [],
        indexes: {},
        uploadToken: null,
        userInfo: null,
        configs: {uploadurl: ''},
        blockTotalCount: 0,
        blockTotalPage: 0,
        blockPageNo: 0,
        userAlls: []
    },
    getters: {
        userList: state => state.userList,
        userCount: state => state.userCount,
        userPageNo: state => state.userPageNo,
        userTotalPage: state => state.userTotalPage,
        blocks: state => state.blocks,
        indexes: state => state.indexes,
        uploadToken: state => state.uploadToken,
        userInfo: state => state.userInfo,
        configs: state => state.configs,
        blockTotalCount: state => state.blockTotalCount,
        blockTotalPage: state => state.blockTotalPage,
        blockPageNo: state => state.blockPageNo,
        userAlls: state => state.userAlls
    },
    mutations: {
        send_msg(state, payload) {
            state.msg = payload._msg
        },
        add_info(state, payload) {
            state.info = Object.assign({}, payload.com_info)
        },
        add_userList(state, payload) {
            state.userList = [].concat(payload.com_userlist)
            state.totleNum = payload.com_total
        },
        add_allUserList(state, payload) {
            state.userAllList = [].concat(payload.com_useralllist)
        }
    },
    actions: {
        getUserAlls({state}) {
            return Api.userAlls().then(({data}) => {
                state.userAlls = data;
            });
        },
        getBlockList({state}, payload) {
            return Api.getBlockList(payload).then(({data}, retCode) => {
                let {items, totalCount, totalPage, pageNo} = data
                state.blocks = items
                state.blockPageNo = pageNo
                state.blockTotalPage = totalPage
                state.blockTotalCount = totalCount
            })
        },
        //修改密码
        updatePwd({commit}, payload) {
            return Api.updatePwd(payload);
        },
        async block({dispatch}, userId) {
            await Api.updateUserStatus({userId: userId, status: 2})
        },
        async resume({dispatch}, userId) {
            await Api.updateUserStatus({userId: userId, status: 0})
        },
        //封禁
        updateUserStatus({dispatch}, payload) {
            return Api.updateUserStatus(payload).then(({data, retCode}) => {
                dispatch('getUserList')
                dispatch('getBlockList')
            });
        },
        //添加用户
        createUser({dispatch}, payload) {
            let self = this
            return Api.createUser(payload).then(({data, retCode}) => {
                dispatch('getUserList')
            })
        },
        //用户列表分页
        getUserList({state}, payload) {
            return Api.userList(payload)
                .then(({data}) => {
                    let {items, totalCount, totalPage, pageNo} = data
                    state.userList = items
                    state.userCount = totalCount
                    state.userTotalPage = totalPage
                    state.userPageNo = pageNo
                })
        },
        getIndexInfo({state}, param) {
            return Api.getIndexInfo(param).then(({data}) => {
                state.indexes = data
            });
        },
        sendMsg({state}, params) {
            return Api.sendMsg(params);
        },
        getToken({state}, params) {
            return Api.getUploadToken(params).then(({data}) => {
                state.uploadToken = data
            })
        },
        updatePhone({state, dispatch}, params) {
            return Api.updatePhone(params).then(() => {
                dispatch('getUserInfo')
            })
        },
        updateIcon({state, dispatch}, params) {
            return Api.updateIcon(params).then(() => {
                dispatch('getUserInfo')
            })
        },
        getUserInfo({state}, params) {
            return Api.getUserInfo(params).then((({data}) => {
                state.userInfo = data
            }))
        },
        configs({state}) {
            Api.configs().then(({data}) => {
                state.configs = data
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/components/user_store.js